export const createAndExportCSV = (headers: string[], csvRows: string[][]) => {
  const csvContent = [headers, ...csvRows]
    .map(row => row.map(cell => `"${String(cell || '').replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'export.csv');

  link.style.visibility = 'hidden';
  document?.body?.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
